import React, { useContext, useLayoutEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import API from '../../api';
import { SnackbarContext, UserContext } from '../../contexts';
import Handler from '../../Handler';
import { ModifyForm } from './modify/ModifyForm';

export const MypageModifyPage = (props) => {
  const { t } = useTranslation();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { userInfo, refreshUserInfo } = useContext(UserContext);
  const [googleAddress, setGoogleAddress] = useState(null);
  const {
    control,
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
      name: '',
      phone: '',
      companyName: '',
      ceoName: '',
      profilePath: '',
      businessNumber: '',
      address: {
        addr1: '',
        addr2: '',
      },
      site: '',
      fax: '',
      businessFile: '',
    },
  });

  useLayoutEffect(() => {
    if (userInfo) {
      const parsedAddress = Handler.jsonParser(userInfo.address);
      setGoogleAddress(parsedAddress?.addr1?.formatted_address);
      reset({
        ...userInfo,
        address: {
          addr1: parsedAddress?.addr1,
          addr2: parsedAddress?.addr2,
        },
        site: userInfo.site,
        fax: userInfo.fax,
        businessFile: userInfo.businessFile,
      });
    }
  }, [userInfo, reset]);

  const onSubmit = (data) => {
    if (data) {
      const address = {
        addr1: data?.address?.addr1,
        addr2: data?.address?.addr2,
      };
      let db_body = {
        name: data.name,
        phone: data.phone,
        address: JSON.stringify(address),
        site: data.site,
        fax: data.fax,
        profilePath: data.profilePath,
      };

      let default_image = Handler.GET_DEFAULT_IMAGE('company');

      if (!db_body.profilePath) {
        db_body.profilePath = default_image;
      }

      API.User.Put(db_body).then(
        (res) => {
          refreshUserInfo();
          updateSnackbar({
            type: 'success',
            open: true,
            message: '회원정보 수정 성공',
          });
        },
        (err) => {
          updateSnackbar({
            type: 'error',
            open: true,
            message: err.data.message,
          });
        },
      );
    }
  };

  if (!userInfo) {
    return <div>Loading...</div>;
  }

  return (
    <article className='basic-page'>
      <article className='content__wrapper'>
        <section className='headding-text__container'>
          <header>
            <h1>{t('MODIFY_MYINFO')}</h1>
          </header>
          <div className='right__box'>{/* <Breadcrumbs type={'small'}></Breadcrumbs> */}</div>
        </section>
        <ModifyForm
          register={register}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          watch={watch}
          setValue={setValue}
          setError={setError}
          errors={errors}
          control={control}
          googleAddress={googleAddress}
          setGoogleAddress={setGoogleAddress}
        />
      </article>
    </article>
  );
};
